export default "__VITE_ASSET__d404960d__"